import React from 'react';

export function escapeRegexCharacters(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

export function renderSuggestion(suggestion) {
  if (suggestion.isNotFound) {
    return <span>Data not found!</span>;
  }
  return <span>{suggestion.name}</span>;
}

export function shouldRenderSuggestions(value) {
  return value.trim().length > 2;
}

export const terminalTypeData = [
  { id: 1, name: 'Domestic' },
  { id: 2, name: 'International' },
  { id: 3, name: 'Hangar' },
  { id: 4, name: 'Military' },
  { id: 5, name: 'Regional' },
  { id: 6, name: 'Unknown' },
];
